<template>
  <div v-if="visible" class="global-loading-mask">
    <Spin fix>
      <Icon type="ios-loading" size="40" class="spin-icon-load"></Icon>
      <div class="loading-content">{{ message }}</div>
      <!-- 新增：进度条 -->
      <div v-if="showProgress" class="progress-bar">
        <div class="progress-inner" :style="{ width: progress + '%' }"></div>
      </div>
    </Spin>
  </div>
</template>

<script>
export default {
  name: 'GlobalLoading',
  data() {
    return {
      visible: false,
      message: 'Loading...',
      showProgress: false,
      progress: 0
    }
  },
  methods: {
    show(options = {}) {
      this.message = options.message || 'Loading...';
      this.showProgress = options.showProgress || false;
      this.progress = options.progress || 0;
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.showProgress = false;
      this.progress = 0;
    },
    updateProgress(percent) {
      if (this.showProgress) {
        this.progress = percent;
      }
    }
  }
}
</script>

<style scoped>
.global-loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999999999999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-content {
  margin-top: 10px;
  font-size: 14px;
  color: #495060;
}

.progress-bar {
  width: 100px;
  height: 6px;
  background-color: #eaeaea;
  border-radius: 3px;
  overflow: hidden;
  margin-top: 8px;
}

.progress-inner {
  height: 100%;
  background-color: #2d8cf1;
  width: 0%;
  transition: width 0.2s ease;
}

.spin-icon-load {
  animation: ani-spin 1s linear infinite;
}

@keyframes ani-spin {
  from { transform: rotate(0deg); }
  50% { transform: rotate(180deg); }
  to { transform: rotate(360deg); }
}
</style>